module.exports = __webpack_public_path__ + "img/m_imgBox_img.2282fcbd.png";